import React from 'react'
import { UsuarioContext } from '../../contexts/UsuarioContext'
import {
  InputText,
  ButtonLoading,
  Alerts,
  ResendOTPButton,
  OTPInput,
} from '../../components/Simple'
import { auth, googleProvider } from '../../config/firebaseContfig' // ajuste o caminho conforme sua estrutura
import { signInWithPopup } from 'firebase/auth'
import { AuthContext } from '../../contexts/AuthContext'
import { Typography, Grid, Button } from '@mui/material'
import { LocalStorage, Services } from '../../services'
import { IoChevronBackOutline } from 'react-icons/io5'
import RouterHook from '../../contexts/RouterHook'
import { MdOutlineEmail } from 'react-icons/md'
import { login1, Logo } from '../../assets'
import { FcGoogle } from 'react-icons/fc'
import { debounce } from 'lodash'
import validator from 'validator'
import CryptoJS from 'crypto-js'
import { UserInfo } from '../../components/Forms/'

import './stylesFL.css'

/* eslint-disable react-hooks/exhaustive-deps */
export default function FormLogin() {
  const serverRouter = RouterHook()
  const { sttAuthCtx, actionsAuth, uiControls, loadsAuth, userInfo } = React.useContext(AuthContext)
  const { actionsUCtx } = React.useContext(UsuarioContext)

  // const [loading, setLoading] = React.useState(false)
  // const [manterConectado, setManterConectado] = React.useState(false)

  function actionGoPage(usuario) {
    let query = ''
    if (usuario.cidade && usuario.estado) {
      query = `${usuario.estado.length === 2 ? usuario.estado : Services.ReturnSiglaEstado(usuario.estado)}-${Services.RemoveCaracteresEspeciais(
        usuario.cidade,
      )}`
    } else {
      query = ':localizacao'
    }
    const url = LocalStorage.get('url-selecionada')
    actionsAuth.clearUiControls()
    // if (manterConectado) {
    //   LocalStorage.set('manter-me-conectado', true)
    // } else {
    //   LocalStorage.remove('manter-me-conectado')
    // }
    if (url) {
      // url esta https://site.agendeiquadras.com.br/centro-esportivo/query pegar ultima parte depois do /
      query = url.url.split('/').pop()
      LocalStorage.remove('url-selecionada')
      LocalStorage.set('back-action', true)
      serverRouter('centro-esportivo', query)
    } else {
      //console.log('query', query)
      serverRouter('home', query.toLowerCase())
    }
  }

  // async function ValidarRafrashToken() {
  //   const req = await actionsAuth.ValidarRefreshToken()

  //   if (req.retorno) {
  //     // Se o refreshToken for valido, pega o usuario do localStorage e redireciona para a home
  //     actionGoPage(user)
  //   } else {
  //     setLoading(false)
  //   }
  // }

  // React.useEffect(() => {
  //   // Se tem o manter conectado, verifica se tem o token no localStorage e usuario
  //   // Se tiver, redireciona para a home
  //   const user = LocalStorage.get('user-loged')
  //   //console.log('user', user)
  //   //console.log('manter conectado', LocalStorage.get('manter-me-conectado'))
  //   //console.log('user-token', LocalStorage.get('user-token'))
  //   //console.log('user-refreshToken', LocalStorage.get('user-refreshToken'))
  //   if (LocalStorage.get('manter-me-conectado') && LocalStorage.get('user-token') && LocalStorage.get('user-refreshToken') && user) {
  //     //console.log('manter conectado')
  //     // Verifica se o refrashToken é valido
  //     ValidarRafrashToken()
  //   } else {
  //     //console.log('não tem token')
  //     setLoading(false)
  //   }
  // }, [])

  React.useEffect(() => {
    function handleKeyDown(e) {
      if (e.key === 'Enter') {
        e.preventDefault()
      }
    }
    if (uiControls.step === 'login') document.title = 'Acessar Conta | Agendei Quadras'
    else if (uiControls.step === 'cadastro') document.title = 'Criar Conta | Agendei Quadras'
    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [uiControls.step, userInfo])

  const debouncedVerifyEmail = debounce(async email => {
    await actionsAuth.VerificaEmail(email)
  }, 50)

  async function RunScript(req) {
    //console.log('req.tokens', req)
    actionsUCtx.handleUsuario(req.usuario)
    // Trechos comentado devido a não criptografia em homologação. Precisa ser alterado em produção
    const bytes = CryptoJS.AES.decrypt(req.tokens.accessToken, import.meta.env.VITE_CRYPTO_KEY)
    const tokenAccess = bytes.toString(CryptoJS.enc.Utf8)
    LocalStorage.set('user-token', tokenAccess)

    const bytesRefresh = CryptoJS.AES.decrypt(
      req.tokens.refreshToken,
      import.meta.env.VITE_CRYPTO_KEY,
    )
    const tokenRefresh = bytesRefresh.toString(CryptoJS.enc.Utf8)
    LocalStorage.set('user-refreshToken', tokenRefresh)

    actionGoPage(req.usuario)
  }

  async function handleVerifyCode() {
    const req = await actionsAuth.VerificaCodigoOTP(userInfo.otpCode)
    // console.log('reqAS', req)
    if (req.retorno === true && req.usuario && req.type === 1) {
      await RunScript(req)
    }
  }

  async function handleGoogleLogin() {
    try {
      googleProvider.setCustomParameters({
        prompt: 'select_account',
      })

      const result = await signInWithPopup(auth, googleProvider)
      const user = result.user
      const idToken = await user.getIdToken()

      const data = {
        user: {
          nome: user.displayName,
          email: user.email,
          telefone: user.phoneNumber,
        },
        idToken: idToken,
      }
      const req = await actionsAuth.LoginComProvider(data)
      if (req.usuario && req.tokens) {
        await RunScript(req)
      }
    } catch (error) {
      // Exiba uma mensagem de erro, por exemplo:
      //ToastMessages.showText('Erro', error.toString())
    } finally {
      actionsAuth.handleLoading('off')
    }
  }

  function handleBackButtonEvent(event) {
    event.preventDefault()
    if (uiControls.step === 'login' || uiControls.step === 'verifEmail') {
      return serverRouter('back')
    } else if (uiControls.step === 'codVerif') {
      return actionsAuth.authStep('login')
    } else if (uiControls.step === 'cadastro') {
      return actionsAuth.authStep('codVerif')
    }
  }

  React.useEffect(() => {
    const handlePopState = event => {
      event.preventDefault()
      handleBackButtonEvent(event)
      window.history.pushState(null, null, window.location.pathname)
    }

    window.history.pushState(null, null, window.location.pathname)
    window.addEventListener('popstate', handlePopState)

    return () => {
      window.removeEventListener('popstate', handlePopState)
    }
  }, [uiControls.step])

  function VerificaCodEnviado() {
    // Tenho uma lista de obj com os email e createdAt, se o email for igual e o createdAt for menor que 1 minuto, retorna true
    //console.log('chamou!!')
    if (sttAuthCtx.listEmails?.email) {
      //console.log('sttAuthCtx.listEmails', sttAuthCtx.listEmails)
      // Verifica se o email já foi enviado
      if (sttAuthCtx.listEmails.email === userInfo.email) {
        const now = Math.floor(Date.now() / 1000) // Tempo atual em segundos
        const elapsedTime =
          now - Math.floor(new Date(sttAuthCtx.listEmails.createdAt).getTime() / 1000)
        //console.log('elapsedTime', elapsedTime)
        if (elapsedTime < 60 && elapsedTime > 0) {
          return true
        }
      }
    }
    if (
      uiControls.emailHelperText ===
      'Você já solicitou um código, aguarde 2 minutos para solicitar novamente'
    )
      return true
    return false
  }

  // if (loading) {
  //   return (
  //     <div className='contain-loading'>
  //       <Loading text={'Carregando...'} color='white' />
  //     </div>
  //   )
  // }

  return (
    <div className='form-login'>
      <div className='form-login-img'>
        <img src={login1} alt='Agendei Quadras' />
      </div>
      <div className='contain-form-login'>
        {uiControls.step === 'login' || uiControls.step === 'verifEmail' ? (
          <div className='contain-inputs'>
            <img className='logo-img-login' src={Logo} alt='Logo Agendei Quadras' />
            <Grid container rowSpacing={0} gap={0} sx={{ margin: '10px 0px 15px 0px' }}>
              <Typography variant='h6' sx={styl.titlePage}>
                AGENDEI QUADRAS
              </Typography>
              <Typography variant='h6' sx={styl.subTitle}>
                Conectamos você com o esporte!
              </Typography>
            </Grid>
            <Grid
              container
              rowSpacing={0}
              gap={0}
              sx={{ display: 'flex', justifyContent: 'center', marginBottom: '15px' }}
            >
              <InputText
                label='E-mail'
                type='text'
                value={userInfo.email}
                sx={{ width: '95%' }}
                placeholder='Digite seu e-mail'
                helperText={loadsAuth === 'email' ? 'Verificando...' : uiControls.emailHelperText}
                error={
                  uiControls.emailHelperText !== ''
                    ? !uiControls.emailValido
                      ? true
                      : false
                    : false
                }
                success={uiControls.emailValido}
                onKeyDown={e => {
                  if (e.key === 'Enter') {
                    e.preventDefault()
                    if (VerificaCodEnviado()) actionsAuth.authStep('codVerif')
                    else actionsAuth.EnviarCodigoEmail(userInfo.email)
                  }
                }}
                onChange={e => {
                  actionsAuth.handleInputChange('email', e)
                  debouncedVerifyEmail(e.target.value)
                }}
              />
            </Grid>
            {/* <Grid container alignItems='center' sx={{ width: '100%', margin: '-10px 0px 10px 0px', padding: '0px 23px' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={manterConectado}
                    onChange={e => setManterConectado(e.target.checked)}
                    sx={{
                      color: 'var(--color-text-low)',
                      '&.Mui-checked': {
                        color: 'var(--color-text-hig)',
                      },
                    }}
                  />
                }
                label='Manter-se conectado'
                sx={{
                  '.MuiFormControlLabel-label': {
                    fontSize: '0.9rem',
                    color: 'var(--color-text-low)',
                    fontFamily: 'jost-light',
                    fontWeight: 'bold',
                  },
                }}
              />
            </Grid> */}

            <Grid
              container
              rowSpacing={0}
              gap={0}
              sx={{
                margin: '10px 0px -10px 0px',
                display: 'flex',
                justifyContent: 'center',
                width: '250px',
              }}
            >
              <ButtonLoading
                fullWidth
                variant='contained'
                sx={styl.buttonLogin}
                startIcon={<MdOutlineEmail />}
                loading={loadsAuth === 'login'}
                onClick={() => {
                  // Verifica se email é valido
                  if (!uiControls.emailValido) {
                    Alerts.swal(
                      'warning',
                      'E-mail inválido',
                      'Por favor, insira um e-mail válido e tente novamente.',
                    )
                  } else if (VerificaCodEnviado()) actionsAuth.authStep('codVerif')
                  else actionsAuth.EnviarCodigoEmail(userInfo.email)
                }}
              >
                {
                  // Verifica se o código já não foi enviado
                  VerificaCodEnviado() ? (
                    <Typography sx={styl.buttonText}>Código já enviado</Typography>
                  ) : (
                    <Typography sx={styl.buttonText}>Continuar com e-mail</Typography>
                  )
                }
              </ButtonLoading>
            </Grid>
            <Grid
              container
              rowSpacing={0}
              gap={0}
              sx={{
                margin: '10px 0px -10px 0px',
                display: 'flex',
                justifyContent: 'center',
                width: '250px',
              }}
            >
              <ButtonLoading
                fullWidth
                variant='contained'
                sx={styl.buttonLogin}
                startIcon={<FcGoogle />}
                loading={loadsAuth === 'login-google'}
                onClick={() => {
                  handleGoogleLogin()
                }}
              >
                <Typography sx={styl.buttonText}>Continuar com Google</Typography>
              </ButtonLoading>
            </Grid>
            {sttAuthCtx.listEmails?.email === userInfo.email && (
              <Grid
                container
                rowSpacing={0}
                gap={0}
                sx={{
                  margin: '10px 0px 15px 0px',
                  display: 'flex',
                  justifyContent: 'center',
                  width: '85%',
                }}
              >
                <ResendOTPButton
                  seconds={60}
                  createdAt={sttAuthCtx.listEmails.createdAt}
                  onResend={() => actionsAuth.EnviarCodigoEmail(userInfo.email)}
                  waitingText={'Reenviar código em {time}'}
                  actionText={'Reenviar código'}
                />
              </Grid>
            )}
          </div>
        ) : uiControls.step === 'codVerif' ? (
          <div className='contain-inputs'>
            <Button
              onClick={e => {
                handleBackButtonEvent(e)
              }}
              sx={styl.backButton}
              startIcon={<IoChevronBackOutline size={25} />}
            />
            <img className='logo-img-login' src={Logo} alt='Logo Agendei Quadras' />
            <Grid container rowSpacing={0} gap={0} sx={{ margin: '10px 0px 15px 0px' }}>
              <Typography variant='h6' sx={styl.titlePage}>
                AGENDEI QUADRAS
              </Typography>
              <Typography variant='h6' sx={styl.subTitle}>
                Conectamos você com o esporte!
              </Typography>
            </Grid>
            <Grid
              container
              rowSpacing={0}
              gap={0}
              sx={{ display: 'flex', justifyContent: 'center', marginBottom: '15px' }}
            >
              <Typography variant='body1'>
                Digite o código de 6 dígitos que enviamos para seu e-mail:{' '}
                <strong>{userInfo.email}</strong>
              </Typography>
            </Grid>
            <Grid
              container
              rowSpacing={0}
              gap={0}
              sx={{ margin: '10px 0px 15px 0px', display: 'flex', justifyContent: 'center' }}
            >
              <OTPInput
                onChange={actionsAuth.handleInputChange}
                error={false}
                helperText={uiControls.otpCodeHelperText}
              />
            </Grid>
            <Grid
              container
              rowSpacing={0}
              gap={0}
              sx={{
                margin: '10px 0px 0px 0px',
                display: 'flex',
                justifyContent: 'center',
                width: '250px',
              }}
            >
              <ButtonLoading
                fullWidth
                variant='contained'
                sx={styl.buttonLogin}
                startIcon={<MdOutlineEmail />}
                disabled={!validator.isEmail(userInfo.email)}
                loading={loadsAuth === 'login'}
                onClick={() => {
                  handleVerifyCode()
                }}
              >
                <Typography sx={styl.buttonText}>Continuar</Typography>
              </ButtonLoading>
            </Grid>
            {sttAuthCtx.listEmails && (
              <Grid
                container
                rowSpacing={0}
                gap={0}
                sx={{
                  margin: '10px 0px 15px 0px',
                  display: 'flex',
                  justifyContent: 'center',
                  width: '85%',
                }}
              >
                <ResendOTPButton
                  seconds={60}
                  createdAt={sttAuthCtx.listEmails.createdAt}
                  waitingText={'Reenviar código em {time}'}
                  actionText={'Reenviar código'}
                  onResend={() => actionsAuth.EnviarCodigoEmail(userInfo.email)}
                />
              </Grid>
            )}
          </div>
        ) : (
          uiControls.step === 'cadastro' && (
            <div className='contain-inputs'>
              <Button
                onClick={e => {
                  handleBackButtonEvent(e)
                }}
                sx={styl.backButton}
                startIcon={<IoChevronBackOutline size={25} />}
              />
              <img className='logo-img-login' src={Logo} alt='Logo Agendei Quadras' />
              <Grid container rowSpacing={0} gap={0} sx={{ margin: '10px 0px 15px 0px' }}>
                <Typography variant='h6' sx={styl.titlePage}>
                  AGENDEI QUADRAS
                </Typography>
                <Typography variant='h6' sx={styl.subTitle}>
                  Conectamos você com o esporte!
                </Typography>
              </Grid>
              <UserInfo desk={true} />
            </div>
          )
        )}
      </div>
    </div>
  )
}

const styl = {
  buttonLogin: {
    display: 'flex',
    justifyContent: 'space-between',
    p: 1.3,
    backgroundColor: '#f6f6f6',
    border: '1px solid #DAE2ED',
    color: 'text.primary',
    '&:hover': {
      backgroundColor: '#f0f0f0',
      transform: 'scale(1.01)',
    },
  },
  buttonText: {
    fontSize: '0.94rem',
    fontWeight: 'bold',
    fontFamily: 'jost-light',
    width: '100%',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  backButton: { position: 'absolute', top: '10px', left: '-25px', zIndex: 2 },
  buttonNewCode: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '10px',
    backgroundColor: 'transparent',
    color: 'var(--color-text-hig)', // Cor do texto
    width: '100%', // Garante que o botão ocupe a largura total disponível
    '&:hover': {
      transform: 'scale(1.05)',
    },
  },
  containButtons: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '50px',
  },
  containTitle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 'auto',
    width: '100%',
  },
  titlePage: {
    fontFamily: 'rez-regular',
    fontSize: '2.4rem',
    textAlign: 'center',
    color: 'var(--color-text-hig)',
    width: '100%',
  },
  subTitle: {
    fontFamily: 'jost-light',
    fontSize: '0.9rem',
    textAlign: 'center',
    fontWeight: 'bold',
    color: 'var(--color-text-pri)',
    width: '100%',
    marginTop: '-12px',
  },
  fixedImg: {
    position: 'absolute',
    zIndex: 1,
    top: '65%',
    left: '46%',
    transform: 'translate(-50%, -50%)',
    width: '98%',
  },
}
